import React, { Component } from 'react';

class DefaultPaymentSource extends Component {
  
  render() {
    const { defaultSource, onChangeCard } = this.props;
    
    return (defaultSource && <div className="default-payment-source">
      <div className="list-group-item">
        <span className="float-right gray small link" style={{marginTop: '0.2rem'}} onClick={onChangeCard}>Change card</span>
        <div>{defaultSource.brand}: &bull; &bull; &bull; &bull; {defaultSource.last4}</div>
      </div>
    </div>);
  }
}


export default DefaultPaymentSource;


// WEBPACK FOOTER //
// ./src/components/billing/DefaultPaymentSource.js